import React from "react";
import Preloader from "../helper/Preloader";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import OrderDetail from "../components/OrderDetail";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import NewsletterTwo from "../components/NewsletterTwo";

const OrderDetailPage = () => {
  return (
    <>
      <ColorInit color={true} />
      <ScrollToTop smooth color="var(--brand-primary)" />
      <Preloader />
      <HeaderThree />
      <Breadcrumb title={"Order Details"} />
      
      <OrderDetail />

      {/* NewsletterTwo */}
      <NewsletterTwo />

      <Footer />
    </>
  );
};

export default OrderDetailPage;